import React from 'react';
// import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
// import DialogActions from '@mui/material/DialogActions';
// import DialogContent from '@mui/material/DialogContent';
// import DialogContentText from '@mui/material/DialogContentText';
// import DialogTitle from '@mui/material/DialogTitle';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import iconCheckCircle from './IconCheckCircle.svg'

export const ModalRecoverPassword = ({ open, handleClose }) => {

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className='p-container-modal-recover-password'
            >
                <div className="modal-content p-modal-content justify-content-center p-2">
                    <div className="modal-header p-modal-border justify-content-center">
                        <img src={iconCheckCircle} alt="icon Check Circle" />
                    </div>
                    <div className="modal-body text-center">
                        <h5>Te hemos enviado un correo con los pasos a seguir</h5>
                        <p className='p-4' style={{fontStyle: 'italic'}}>
                            *Si no logras encontrarlo, revisa tu bandeja de spam.
                        </p>
                    </div>
                    <div className="modal-footer p-modal-border justify-content-center">
                        <button type="button" className="btn p-btn-primary" data-bs-dismiss="modal" onClick={handleClose}>OK</button>

                    </div>
                </div>
            </Dialog>
        </div>
    )
}
